

export function desgloseEventsByDay(
    events: any[],
    prefix: string,
    dateField: 'RangeDateInfo' | 'Fecha'
): any[] {
    const result: any[] = [];

    for (const event of events) {
        const dateInfo = event[dateField] as string;
        const dates = extractDatesFromRange(dateInfo);

        for (const date of dates) {
            const { ...rest } = event;
            result.push({
                ...rest,
                customDate: date,
                RangeDateInfo: dateInfo,
                customId: `${prefix}-${rest.Id}-${date}`,
            });
        }
    }

    return result;
}

/**
 * Extrae todas las fechas de un rango en diferentes formatos
 * @param rangeText Texto que contiene el rango de fechas
 * @returns Array de fechas en formato YYYY-MM-DD
 */
function extractDatesFromRange(rangeText: string): string[] {
    // Expresión regular para capturar diferentes formatos de fecha
    const dateFormats = [
        // Formato "dd/MM/yyyy de HH:mm am a HH:mm pm"
        /(\d{2}\/\d{2}\/\d{4}) de \d{2}:\d{2} [ap]m a (\d{2}\/\d{2}\/\d{4}) \d{2}:\d{2} [ap]m/,
        // Formato "dd/MM/yyyy de HH:mm am a HH:mm pm"
        /(\d{2}\/\d{2}\/\d{4}) de \d{2}:\d{2} [ap]m a \d{2}:\d{2} [ap]m/,
        // Formato "dd/MM/yyyy a dd/MM/yyyy"
        /(\d{2}\/\d{2}\/\d{4}) a (\d{2}\/\d{2}\/\d{4})/,
        // Formato "dd/MM/yyyy - dd/MM/yyyy"
        /(\d{2}\/\d{2}\/\d{4}) - (\d{2}\/\d{2}\/\d{4})/,
        // Formato "dd/MM/yyyy"
        /(\d{2}\/\d{2}\/\d{4})/
    ];

    let startDate: Date | null = null;
    let endDate: Date | null = null;

    // Probar cada formato hasta encontrar uno que coincida
    for (const format of dateFormats) {
        const match = rangeText.match(format);
        if (match) {
            // El primer grupo siempre es la fecha de inicio
            startDate = parseDate(match[1]);
            
            // Algunos formatos tienen fecha final (segundo grupo de captura)
            if (match[2]) {
                endDate = parseDate(match[2]);
            } else {
                // Si no hay fecha final, es el mismo día
                endDate = startDate;
            }
            break;
        }
    }

    if (!startDate || !endDate) {
        // Si no se pudo parsear, devolvemos un array vacío
        return [];
    }
    return getDatesInRange(startDate, endDate);
}

/**
 * Parsea una fecha en formato dd/MM/yyyy a objeto Date
 * @param dateStr Fecha en formato dd/MM/yyyy
 * @returns Objeto Date
 */
function parseDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day, 12, 0);
}

/**
 * Genera todas las fechas entre startDate y endDate
 * @param startDate Fecha de inicio
 * @param endDate Fecha de fin
 * @returns Array de fechas en formato YYYY-MM-DD
 */
function getDatesInRange(startDate: Date, endDate: Date): string[] {
    const dates: string[] = [];
    const currentDate = new Date(startDate);
    
    while (currentDate <= endDate) {
        dates.push(formatDate(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    
    return dates;
}

/**
 * Formatea una fecha a YYYY-MM-DD
 * @param date Objeto Date
 * @returns Fecha formateada
 */
function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
